import { IllustrationCard } from '@/common/components/Illustrations/IllustrationCard';
import { ICard } from '@/common/integrations/menhir/employee/card/card.types';
import { t } from 'i18next';

export function getTitle(card: ICard) {
  if (card.status === 'inactive' && card.format !== 'digital') {
    return t('card.inactive.title');
  } else {
    return `**** **** **** ${card.panLastDigits ?? '****'}`;
  }
}

export function getBadgeText(card: ICard) {
  if (card.status === 'active' && card.isExpiring) {
    return t('card.badge.expiring');
  } else if (card.format === 'digital' && card.status === 'active') {
    return t('card.badge.digital');
  } else {
    return t(`card.${card.status}.status`);
  }
}

export function getDescription(card: ICard) {
  if (card.status === 'expired') {
    return undefined;
  } else if (card.format === 'digital' && card.status === 'active') {
    return t('card.active.description');
  } else {
    return t(`card.${card.status}.description`);
  }
}

export function getIconBadgeColor(card: ICard) {
  switch (card.status) {
    case 'active':
      return 'accentSecondary40';
    case 'expired':
    case 'cancelled':
      return 'systemDisabled20';
    case 'locked':
      return 'systemInfo20';
    default:
      return undefined;
  }
}

export function getBackgroundColor(card: ICard) {
  if (card.status === 'inactive') {
    return 'accentSecondary20';
  } else {
    return undefined;
  }
}

export function getIllustration(card: ICard) {
  if (card.status === 'inactive') {
    return {
      asset: <IllustrationCard height={100} width={100} />,
    };
  } else {
    return undefined;
  }
}
